export enum QuoteHistoricalActionEnum {
  CartChekout = 1,
  JobChekout = 2,
  CartChekoutTotalLoss = 3,
  ChangeStatus = 4,
  Created = 5,
  CreatedIntegration = 6,
  OfferRequested = 7,
  PartAnswered = 8,
  PartAnsweredManually = 9,
  PartAddedToCart = 10,
  PartRemovedFromCart = 11,
  Edited = 12,
  Canceled = 13,
  PreQuote = 14,
  ChangeStatusManualQuote = 16,
  QuoteChangedByAccordion = 17,
  ImageInserted = 18,
  Manualcorrected = 19,
  PartCanceled = 20,
  Requoted = 21,
  BodyshopConfirmed = 22,
  CreatedByIntegration = 23,
  PartRequoted = 24,
  CreatedByrequote = 25,
  CreatedIntegrationXlsx = 26,
  ImageDeleted = 27,
  CreatedByrequoteNational = 28,
  PartGlass = 29,
  PartTire = 30,
  PartAnsweredManuallyByBuyer = 31,
  NoSupplierFound = 32,
  QuoteReopened = 33,
  PartsAnsweredByIntegration = 34,
  SendUpdatesManuallyQueued = 35,
  PartMovedToApproved = 40,
  PartMovedToRejected = 41,
  UnavaiblePartMovedToRejected = 42,
}
